import helper from '../../../helpers/steinerHelper';

export const actionTypes = helper.createActionTypes('specsServices');
export const actions = helper.createActions('specsServices', actionTypes);
